// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Result from "../../../../../node_modules/rescript/lib/es6/belt_Result.js";

function toString(status) {
  switch (status) {
    case /* TeleAgent */0 :
        return "tele_agent";
    case /* Web */1 :
        return "web";
    case /* Ios */2 :
        return "ios";
    case /* Android */3 :
        return "android";
    case /* MarketingAdmin */4 :
        return "marketing_admin";
    case /* CronJob */5 :
        return "cron_job";
    case /* Api */6 :
        return "api";
    case /* Ivr */7 :
        return "ivr";
    case /* Website */8 :
        return "website";
    case /* Ondc */9 :
        return "ondc";
    case /* DesktopWeb */10 :
        return "desktop_web";
    
  }
}

function fromString(statusString) {
  var match = $$String.lowercase_ascii(statusString);
  switch (match) {
    case "android" :
        return /* Android */3;
    case "api" :
        return /* Api */6;
    case "cron_job" :
        return /* CronJob */5;
    case "desktop_web" :
        return /* DesktopWeb */10;
    case "ios" :
        return /* Ios */2;
    case "ivr" :
        return /* Ivr */7;
    case "marketing_admin" :
        return /* MarketingAdmin */4;
    case "ondc" :
        return /* Ondc */9;
    case "tele_agent" :
        return /* TeleAgent */0;
    case "web" :
        return /* Web */1;
    case "website" :
        return /* Website */8;
    default:
      return Pervasives.failwith("Invalid filter_source");
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

var t_encode = toString;

var source = {
  hd: /* TeleAgent */0,
  tl: {
    hd: /* Web */1,
    tl: {
      hd: /* Ios */2,
      tl: {
        hd: /* Android */3,
        tl: {
          hd: /* MarketingAdmin */4,
          tl: {
            hd: /* CronJob */5,
            tl: {
              hd: /* Api */6,
              tl: {
                hd: /* Ivr */7,
                tl: {
                  hd: /* Website */8,
                  tl: {
                    hd: /* Ondc */9,
                    tl: {
                      hd: /* DesktopWeb */10,
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

export {
  source ,
  toString ,
  fromString ,
  t_decode ,
  t_encode ,
  
}
/* No side effect */
